export default __webpack_public_path__ + "static/media/SCE.a9869ac0.gif";